import { useState } from "react";
import { ClientSideProductCard as ProductCard } from "@/components/ProductCard";
import { SearchResult } from "@/components/Search/types";
import { convertHitToProductCardProps } from "@/components/Search/utils/convertHitToProductCardProps";
import { PRODUCT_INDEX_EN } from "@/constants/algolia";

type ProductCardListProps = {
  cards?: SearchResult[];
};

export const ProductCardList = ({ cards = [] }: ProductCardListProps) => {
  const [expanded, setExpanded] = useState(false);
  const VISIBLE_COUNT = 8;
  const indexName = PRODUCT_INDEX_EN as string;

  const visibleCards = expanded ? cards : cards.slice(0, VISIBLE_COUNT);

  return (
    <>
      <div className="mt-8 grid gap-6 grid-cols-[repeat(auto-fit,minmax(270px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(270px,1fr))]">
        {visibleCards.map((card) => {
          const cardProps = convertHitToProductCardProps(card, indexName);
          return (
            <ProductCard
              className="max-w-none"
              key={cardProps.uuid}
              {...cardProps}
              location="search-results"
            />
          );
        })}
      </div>

      {cards.length > VISIBLE_COUNT && (
        <div className="mt-16 flex justify-center">
          <button
            type="button"
            aria-expanded={expanded}
            onClick={() => setExpanded((s) => !s)}
            className="text-base text-gray-800 underline underline-offset-[3px] hover:text-gray-800"
          >
            {expanded ? "Show less" : "Show more"}
          </button>
        </div>
      )}
    </>
  );
};
